import React, { useState } from "react";
import { AiOutlineMenu } from "react-icons/ai";
import { Link } from "react-router-dom";
import logo from '../../../assets/images/myaniture/326391513_912063713158960_7875183330785571306_n.jpg'
import { BsCart } from "react-icons/bs";
import paths from "../../../routes/paths";
import { IoIosArrowDown } from "react-icons/io";
const Header = ({SlideData}) => {
     const [headerOpen, setHeaderOpen] = useState(true);
     const [serchTerm, setSearchTerm] = useState("");
  return (
    <>
      <nav className="my-5 relative flex items-center gap-3 px-4 justify-between  md:hidden">
        <Link to={paths.home}>
          <img src={logo} className="w-10 rounded-full h-auto" alt="" />
        </Link>
        <div className="flex items-center">
          <div className="flex flex-col relative">
            <div className="flex shadow-sm">
              <input
                value={serchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                type="text"
                className="block w-[55vw]  px-4 py-2  bg-white border 
       focus:outline-none "
                placeholder="What are you looking for ? ..."
              />
              <button className="px-4 text-white bg-[#343434]  ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </button>
            </div>
            {serchTerm.length != "" && (
              <div className=" md:w-[90%] w-full shadow-lg absolute top-11 z-20 pb-5 bg-white ">
                <ul>
                  {SlideData?.filter((pd) => {
                    if (serchTerm == "") {
                      return pd;
                    } else if (
                      pd.name
                        .toLowerCase()
                        .includes(serchTerm.toLocaleLowerCase())
                    ) {
                      return pd;
                    }
                  }).map((item) => (
                    <li
                      className="flex gap-5 hover:bg-[#3B777917] p-2 bg-white"
                      key={item.id}
                    >
                      <div>
                        <img className="w-16 " src={item?.img} alt="" />
                      </div>
                      <div>
                        <p className="text-lg pr-12">{item?.name}</p>
                        <p className="text-[#3B7779]">{item?.price}</p>
                      </div>
                    </li>
                  ))}
                  <p className="text-center text-[#3B7779]">View All results</p>
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className="dropdown  dropdown-end hover:scale:105 transition">
          <div className="bg-white p-1 rounded-full" tabIndex={0}>
            <AiOutlineMenu className="cursor-pointer   text-black " />
          </div>

          <ul
            tabIndex={0}
            className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-56 mt-5"
          >
            <>
              <li>
                <Link to={paths.home} className="uppercase text-xs ">
                  home
                </Link>
              </li>
            </>
            <li className=" text-sm">
              <a href="">IKEA</a>
            </li>
            <li className=" text-sm ">
              <a href="">School Furniture</a>
            </li>
            <li className=" text-sm ">
              <a href="">Myaniture Mall</a>
            </li>
            <li className=" text-sm ">
              {" "}
              <a href="">Wholesale</a>
            </li>
            <li className=" text-sm ">
              <a href="">New Products</a>
            </li>

            <li>
              <a
                href="https://fitbaemm.com/?cat=sale"
                className="uppercase text-xs text-red-700"
              >
                Sale
              </a>
            </li>
          </ul>
        </div>
      </nav>
      <div>
        {" "}
        <div className=" md:block hidden textfont">
          {" "}
          <div class="navbar  px-5 z-50 pt-4">
            <div className="navbar-start gap-4">
              <div
                className="cursor-pointer"
                onClick={() => setHeaderOpen(!headerOpen)}
              >
                <AiOutlineMenu size={24} />
              </div>
              <div>
                <img src={logo} className="w-16" alt="" />
              </div>
            </div>

            <div className="flex items-center">
              <div className="flex flex-col relative">
                <div className="flex shadow-sm">
                  <input
                    value={serchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    type="text"
                    className="block w-[60vw] px-4 py-2  bg-white border 
       focus:outline-none "
                    placeholder="What are you looking for ? ..."
                  />
                  <button className="px-4 text-white bg-[#343434]  ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </button>
                </div>
                {serchTerm.length != "" && (
                  <div className=" w-[90%] shadow-lg absolute top-11 z-20 pb-5 bg-white ">
                    <ul>
                      {SlideData?.filter((pd) => {
                        if (serchTerm === "") {
                          return pd;
                        } else if (
                          pd.name
                            .toLowerCase()
                            .includes(serchTerm.toLocaleLowerCase())
                        ) {
                          return pd;
                        }
                      }).map((item) => (
                        <li
                          className="flex gap-5 hover:bg-[#3B777917] p-2 bg-white"
                          key={item.id}
                        >
                          <div>
                            <img className="w-16 " src={item?.img} alt="" />
                          </div>
                          <div>
                            <p className="text-lg pr-12">{item?.name}</p>
                            <p className="text-[#3B7779]">{item?.price}</p>
                          </div>
                        </li>
                      ))}
                      <p className="text-center text-[#3B7779]">
                        View All results
                      </p>
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <div class="navbar-end">
              <div class="row">
                <div className="ms-10">
                  <BsCart size={24} />
                </div>
              </div>
            </div>
          </div>
          {headerOpen && (
            <div class="navbar transition-all px-5 z-50 p-0">
              {/* <div className="navbar-start gap-4"></div> */}

              <div className=" max-w-6xl mx-auto">
                <div className="flex ">
                  <ul class="flex gap-4 ">
                    <a className="nav-link">
                      <li className=" p-1 text-sm ">Home</li>
                    </a>
                    <li className="p-1 nav-link text-sm">IKEA</li>
                    <li className="p-1 text-sm nav-link">School Furniture</li>
                    <li className="p-1 text-sm nav-link">Myaniture Mall</li>
                    <li className="p-1 text-sm nav-link"> Wholesale</li>
                    <li className="p-1 text-sm nav-link">New Products</li>
                    <Link className="p-1 text-sm nav-link" to="">
                      <li>
                        <a>sales</a>
                      </li>
                    </Link>
                  </ul>
                </div>
              </div>
              {/* <div class="navbar-end"></div> */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;
